export enum AlertModalEnum {
    ActivateSimCard = 'ActiveSimCard',
    InvoiceSituation = 'InvoiceSituation',
    OverspentLimitReached = 'OverspentLimitReached'
}